import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ButtonDanger from "../../common/buttonDanger";
import ButtonIcon from "../../common/buttonIcon";
import ButtonSubmit from "../../common/buttonSubmit";
import Moment from 'react-moment';
import AlertMessageModal from "../../alertMessageModal"
import { useEffect, useState } from "react";
import moment from "moment"
import EditTimeslot from "./editTimeslot";
import RepeatTimeslot from "./repeatTimeslot";
import SuccessMessageBox from "../../common/successMessageBox";
import { useAppDispatch } from "../../../redux";
import { deleteTimeslotById, forceTimeslotUpdate } from "../../../redux/reducer/timeslotReducer";
import AlertMessage from "../../alertMessage";
import InfoMessage from "../../infoMessage";
import { HttpService } from "../../../services/HttpService";
import BoxPrenotationLinks from "../../boxPrenotationLinks";
import { isGroupLinkActive, isGroupLinkChild, isGroupLinkParent } from "../../../utils/helpers";

const ViewTimeslot = (props: any) => {
  const { t } = useTranslation();
  const { eventId } = useSelector((state: any) => state.login);
  const { timeslotDetailUpdate } = useSelector((state: any) => state.timeslot);

  let idEvent = props.idEvent ?? "";
  const [modalDelete, setmodalDelete] = useState(false);
  const dispacth = useAppDispatch();
  const [event, setEvent] = useState<any>(null);
  const [showPopUpManager, setShowPopUpManager] = useState("");
  const [prenotations, setPrenotations] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [service, setService] = useState<any>({})
  let obbjectTranslate = {
    time: moment(event?.start).format("ll HH:mm") + " - " + moment(event?.end).format("HH:mm"),
    service: service?.name
  }
  const deleteTimeslot = async () => {
    const result = await dispacth(deleteTimeslotById(idEvent));
    if (result.status === 200) {
      props.closePopUp();
      setmodalDelete(false)
      dispacth(forceTimeslotUpdate())
    }
    else {
      setErrorMessage(result.data?.error ?? t('error.generic'));
      console.log("Data Error", result.data?.error);
    }
    ;
  }


  const [successMessage, setSuccessMessage] = useState("");

  const loadBookings = async () => {
    let result: any = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/${idEvent}/bookings`);
    if (result.status === 200) {
      setPrenotations(result.data)
    }
  }

  useEffect(() => {
    loadBookings()
  }, [idEvent, event?.savedAttendances, timeslotDetailUpdate])

  const changeMessagesuccess = (message: string) => {
    setSuccessMessage(message);
    setTimeout(() => (setSuccessMessage("")), 2000)
  }



  const clickPrenotationLink = (bookingId: string) => {
    props.clickPrenotationLink(
      moment(new Date(event.startDate)).format('YYYY-MM-DD'),
      event._id, // timeslot ID
      bookingId
    )
  }

  const fetchData = async () => {
    let timeslot;
    const timeslotResult = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot/${idEvent}`);
    if (timeslotResult.status === 200) {
      timeslot = timeslotResult.data
      timeslot.start = new Date(timeslot.startDate)
      timeslot.end = new Date(timeslot.endDate)
      setEvent(timeslot)
    }

    const timeslotCategoryResult = await HttpService.get(`${process.env.REACT_APP_API}/t4event/api/v01/event/${eventId}/timeslot-category/${timeslot.category}`);
    if (timeslotCategoryResult.status === 200) {
      const timeslotCategory = timeslotCategoryResult.data
      setService(timeslotCategory)
    }
  }

  // fetch data
  useEffect(() => {
    fetchData()
    setShowPopUpManager("")
  }, [idEvent, timeslotDetailUpdate])

  return (
    ((event) ?
      <>
        <div className="ViewTimeslot">
          <div className="header">
            <div className="row ">
              <div className="col-10">
                <h6><b><Moment format="LL">{event?.start}</Moment>  </b></h6>
                <h6><Moment format="HH:mm">{event?.start}</Moment> - <Moment format="HH:mm">{event?.end}</Moment></h6>
              </div>
              <div className="col-2 text-right">
                <ButtonIcon handleClick={props.closePopUp} icon="close" />
              </div>
            </div>
          </div>
          <div className="body">
            <div className="bodySection">
              <h5 className="service"><b>{t('service')}</b> {service?.name}</h5>
              {isGroupLinkActive(service.groupLink) &&
                <InfoMessage description={t('timeslot.linked-message')} additionalClass="mt-1" />
              }

            </div>
            <div className="bodySection">
              <h5 className="service"><b>{t('notification-email')}</b></h5>
              {((service?.emails?.length) ?
                <>
                  <ul className="emailList">
                    {(service?.emails.map((email: any, index: number) => (
                      <li key={index}>{email}</li>
                    )))}
                  </ul>
                  <InfoMessage description={t('info-timeslot')} additionalClass="mt-1" />
                </>
                :
                <p className="service">{t('no-email')}</p>
              )}
            </div>
            <div className="bodySection seats">
              <p className="service m-0"><b>{t('seats')}:</b> {event.maximumAttendances - event.savedAttendances}</p>
              <p className="service m-0">
                <b>{t('reserved-seats')}:</b>
                &nbsp;{event.savedAttendances}
                {isGroupLinkActive(service.groupLink) &&
                  <>
                    &nbsp;<span
                      className="material-icons"
                      title={t('timeslot.linked-seats-message')}
                    >
                      help
                    </span>
                  </>
                }
              </p>
            </div>

            <SuccessMessageBox successMessage={successMessage} />
          </div>

          {((!event?.deleted) ?
            <div className="footer">
              <div className="row">
                {/* If uncomment code view a button to repeat time slot */}
                {/* <div className="col-lg-6 p-2">
                  <ButtonWhite handleChange={() => (setShowPopUpManager("Repeat"))} textButton="Ripeti fascia" />
                </div> */}
                <div className="col-lg-6 p-2" title={isGroupLinkChild(service.groupLink) ? t("timeslot.linked-child-edit-title") : ""}>
                  <ButtonSubmit
                    disabled={service.disabled || isGroupLinkChild(service.groupLink)}
                    handleChange={() => (setShowPopUpManager("Edit"))}
                    textButton="Modifica fascia"
                  />
                </div>
                <div className="col-lg-6 p-2" title={isGroupLinkChild(service.groupLink) ? t("timeslot.linked-child-delete-title") : ""}>
                  <ButtonDanger
                    disabled={service.disabled || isGroupLinkChild(service.groupLink)}
                    textButton="Elimina fascia"
                    handleChange={() => (setmodalDelete(true), setErrorMessage(""))}
                  />
                </div>
                {(service.disabled ?
                  <div className="col-lg-12 p-2">
                    <AlertMessage description={t('service-disabled-timeslot-description')}
                      additionalClass="mt-4" />
                  </div>
                  :
                  <></>
                )}
                {(event.savedAttendances > 0 ?
                  <div className="col-lg-12 p-2">
                    <AlertMessage description={t('danger-timeslot-delete')}
                      additionalClass="mt-2" />
                  </div>
                  :
                  <></>
                )}
              </div>
            </div>
            :
            <></>
          )}

          <BoxPrenotationLinks clickPrenotationLink={clickPrenotationLink} prenotations={prenotations} />

        </div>
        <EditTimeslot
          changeMessagesuccess={changeMessagesuccess}
          closePopUp={() => (setShowPopUpManager(""))}
          showPopUpManager={showPopUpManager}
          event={event}
          onSave={fetchData}
          isParent={isGroupLinkParent(service.groupLink)}
        />
        <RepeatTimeslot changeMessagesuccess={changeMessagesuccess} closePopUp={() => (setShowPopUpManager(""))} showPopUpManager={showPopUpManager} idEvent={idEvent} />
        <AlertMessageModal
          title={t('delete')}
          description={<p>{t('popup-timeslot.delete-timeslot', obbjectTranslate) as string}</p>}
          closeModal={() => (setmodalDelete(false))}
          titleButtonSecondary={t('popup-timeslot.button-cancel')}
          handleClosePrimary={() => { deleteTimeslot() }}
          titleButtonPrimary={t('popup-timeslot.button-delete')}
          handleCloseSecondary={() => (setmodalDelete(false))}
          alertMessage={isGroupLinkParent(service.groupLink) ? t('timeslot.linked-parent-delete-message') : ''}
          errorMessage={errorMessage}
          show={modalDelete} />
      </>
      :
      <></>))
}
export default ViewTimeslot